const theme = {
    mainColor: '#FFD736',
    mainBlack: '#212121'
};

export default theme;